import {Vector3} from 'three'

export const TIME_RANGES = {
    // morning: {start: 4 * 60, end: 10 * 60}, // 4 AM to 10 AM
    morning: {start: 240, end: 600}, // 4 AM to 10 AM
    // day: {start: 10 * 60, end: 16 * 60},    // 10 AM to 4 PM
    day: {start: 600, end: 960},    // 10 AM to 4 PM
    // evening: {start: 16 * 60, end: 22 * 60}, // 4 PM to 10 PM
    evening: {start: 960, end: 1320}, // 4 PM to 10 PM
    // night: {start: 22 * 60, end: 28 * 60}   // 10 PM to 4 AM
    night: {start: 1320}   // 10 PM to 4 AM
}

export const RECALCULATION_INTERVAL_MS = 900000 // 15 minutes
export const QUARTER_DAY = 360 // 6 Hours (in minutes)

export const ROOM_SIZE = [10.5, 6.1, 6.09]
export const ROOM_POSITION = [0.9, 6.4, 0.9]

export const COMPUTER_SCREEN_PROPS = {
    position: [0.8, 5.45, 7.32],
    rotation: [0, Math.PI, 0],
    scale: [1.81, 2.09, 1]
}

export const TROPHY_BOX_PROPS = {
    position: [4.71, 9.55, 7.17],
    scale: [1.4, 1.5, 1]
}
export const TABLET_BOX_PROPS = {
    position: [6.95, 4.9, 7],
    scale: [1.6, 0.7, 1.1]
}
export const LINKEDIN_BOX_PROPS = {
    position: [7.8, 3, 7.5],
    scale: [1, 1, 1]
}
export const TARGET_BOX_PROPS = {
    position: [13.1, 11.1, 7.55],
    scale: [1, 1.18, 1.05]
}
export const STRAWBERRY_BOX_PROPS = {
    position: [0.65, 7.3, 7.5],
    scale: [2.7, 1.2, 1.1]
}

export const cornerRotations = [
    Math.PI * 0.5,
    0,
    Math.PI,
    Math.PI * 1.5
]

export const targetPositionsStart = [
    [11.2, 9.4, 7.25],
    [13, 13.1, 7.25],
    [13.5, -0.5, 7.25],
    [9.5, 5.5, 7.25],
    [-9.5, 13.1, -5],
    [3, 9.6, 7.25],
    [1, 0, -7.25],
    [13, 4, -5.5],
    [10, 5, 0],
    [-5, -0.5, 4.5],
]
export const targetPositionsEnd = [
    [9.4, 9.4, 7.25],
    [6.5, 13.1, 7.25],
    [13.5, 5.5, 7.25],
    [9.5, -0.5, 7.25],
    [-9.5, 13.1, 7.25],
    [-1, 9.6, 7.25],
    [1, 0, -3],
    [13, 11, -5.5],
    [-10, 5, 0],
    [-5, -0.5, 4.5],
]

export const targetsAxisNumber = [
    0, 0, 1, 1, 2, 0, 2, 1, 0, 0
]

export const targetsAxis = [
    'x', 'x', 'y', 'y', 'z', 'x', 'z', 'y', 'x', 'x'
]

export const INFO_PANEL_DATA = {
    trophy: {
        id: 'trophy',
        title: 'ThreeJs Journey Certificate',
        description: ', this is the knowledge that made all of this possible. If you are interested in 3D experiences for the web, this course is all you need!',
        link: 'https://threejs-journey.com/',
        linkText: 'ThreeJs Journey',
        cameraOffset: new Vector3(0, 0, -5),
    },
    tablet: {
        id: 'tablet',
        title: 'Tablet',
        description: 'This tablet has some music on it. Should We play some?',
        cameraOffset: new Vector3(0, 3, -5),
    },
    linkedin: {
        id: 'linkedin',
        title: 'LinkedIn',
        description: `It says 'in'. Where could it lead? (Feel free to connect with me!) Actually its my twitter I'm not ready to put my name out there yet ^^`,
        link: 'https://www.twitter.com/Khk7ShzSYEHb4o5',
        linkText: 'Connect!',
        cameraOffset: new Vector3(0, 3, -5),
    },
    info: {
        id: 'info',
        title: 'Experience Guide',
        description: 'Description',
        // cameraOffset: new Vector3(0, 0, 0),
    },
    credits: {
        id: 'credits',
        title: 'Credits',
        description: 'Jhin and Sivir model taken from modelviewer.lol, copyright Riot Games. Luigi model from mario kart tour copyright nintendo, font harmonyOs from hwawei, strawberryjamcroissant pixelart from @nimasain on twitter',
        // cameraOffset: new Vector3(0, 0, 0),
    },
    target: {
        id: 'target',
        title: 'Break the Targets',
        description: 'Break the targets!',
        cameraOffset: new Vector3(0, 10, -5),
    },
    strawberry: {
        id: 'strawberry',
        title: 'Art Piece ?',
        description: 'An interesting piece of art. What do you think it means?',
        cameraOffset: new Vector3(0, 3, -5),
    }
}

export const DEFAULT_CAMERA_POS = new Vector3(-5.7, 10, -24.8)
export const DEFAULT_TARGET_POS = new Vector3(0, 5, 0)

export const START_CAMERA_POS = new Vector3(-50, 30, 15)
export const START_TARGET_POS = new Vector3(0, -20, 0)

export const ALBUM_COVERS = [
    './images/baek.png',
    './images/do.png',
    './images/exo.png',
    './images/gw.png',
    './images/rv.png',
    './images/target.png',
]

export const SONG_NAMES = [
    'Bambi - Baekhyun',
    'Somebody - D.O.',
    'Cream Soda - EXO',
    'The Beast Emerges - Maclaine Diemer, Bobby Rose',
    'Chill Kill - Red Velvet',
    'Break the Targets - Hirokazu Ando'
    // 'SONG #1',
    // 'SONG #2',
    // 'SONG #3',
    // 'SONG #4',
    // 'SONG #5',
]

export const TOTAL_SONGS = 5

export const SONGS_FILEPATHS = [
    './music/baek.mp3',
    './music/do.mp3',
    './music/exo.mp3',
    './music/gw.mp3',
    './music/rv.mp3',
    './music/target.mp3',
]

export const ALBUM_GRADIENTS = [
    // baek
    `radial-gradient(18% 28% at 45% 32%, #A86E4EFF 7%, #073AFF00 100%),
    radial-gradient(31% 43% at 7% 98%, #EACCAFFF 24%, #073AFF00 100%),
    radial-gradient(35% 56% at 91% 74%, #E5CAADF5 9%, #073AFF00 100%),
    radial-gradient(74% 86% at 67% 38%, #A6643CF5 3%, #073AFF00 64%),
    linear-gradient(130deg, #E9BC92FF 0%, #35261BFF 100%)`,
    // do
    `radial-gradient(18% 28% at 45% 32%, #AE6A3BFF 7%, #073AFF00 100%),
    radial-gradient(31% 43% at 7% 98%, #5B694FFF 24%, #073AFF00 100%),
    radial-gradient(35% 56% at 91% 74%, #000000F5 9%, #073AFF00 100%),
    radial-gradient(74% 86% at 67% 38%, #EBD5B4F5 3%, #073AFF00 64%),
    linear-gradient(130deg, #85805DFF 0%, #95381DFF 100%)`,
    // exo
    `radial-gradient(18% 28% at 45% 32%, #F1EAF2FF 7%, #073AFF00 100%),
    radial-gradient(31% 43% at 7% 98%, #4D1724FF 24%, #073AFF00 100%),
    radial-gradient(35% 56% at 91% 74%, #9B7450F5 9%, #073AFF00 100%),
    radial-gradient(74% 86% at 67% 38%, #C37B8CF5 3%, #073AFF00 64%),
    linear-gradient(130deg, #09060CFF 0%, #C37B8CFF 100%)`,
    // gw2
    `radial-gradient(31% 43% at 7% 98%, #F8F5ECFF 24%, #073AFF00 100%),
    radial-gradient(35% 56% at 91% 74%, #D0AB68F5 9%, #073AFF00 100%),
    radial-gradient(74% 86% at 67% 38%, #E3D6BEF5 3%, #073AFF00 64%),
    linear-gradient(130deg, #D6A458FF 0%, #FBF8F4FF 100%)`,
    // rv
    `radial-gradient(28% 28% at 24% 50%, #504250FF 7%, #073AFF00 100%),
    radial-gradient(35% 35% at 7% 98%, #939475FF 24%, #073AFF00 100%),
    radial-gradient(45% 45% at 91% 74%, #1B2426F5 9%, #073AFF00 100%),
    radial-gradient(74% 86% at 67% 38%, #000000F5 3%, #073AFF00 64%),
    linear-gradient(130deg, #A1242AFF 1%, #878787FF 100%)`,
    // rv
    `radial-gradient(28% 28% at 24% 50%, #504250FF 7%, #073AFF00 100%),
    radial-gradient(35% 35% at 7% 98%, #939475FF 24%, #073AFF00 100%),
    radial-gradient(45% 45% at 91% 74%, #1B2426F5 9%, #073AFF00 100%),
    radial-gradient(74% 86% at 67% 38%, #000000F5 3%, #073AFF00 64%),
    linear-gradient(130deg, #A1242AFF 1%, #878787FF 100%)`,
]

export const SONGS_BPM = [
    64,
    89,
    156,
    148,
    148,
    148,
]

/*
const SONGS = {
    baek: {
        name: 'Bambi - Baekhyun',
        filepath: SONGS_FILEPATHS[0],
        bpm: SONGS_BPM[0],
        gradient: ALBUM_GRADIENTS[0],
        cover: ALBUM_COVERS[0],
    },
    do: {
        name: 'Somebody - D.O.',
        filepath: SONGS_FILEPATHS[1],
        bpm: SONGS_BPM[1],
        gradient: ALBUM_GRADIENTS[1],
        cover: ALBUM_COVERS[1],
    },
    exo: {
        name: 'Cream Soda - EXO',
        filepath: SONGS_FILEPATHS[2],
        bpm: SONGS_BPM[2],
        gradient: ALBUM_GRADIENTS[2],
        cover: ALBUM_COVERS[2],
    },
    gw2: {
        name: 'The Beast Emerges - Maclaine Diemer, Bobby Rose',
        filepath: SONGS_FILEPATHS[3],
        bpm: SONGS_BPM[3],
        gradient: ALBUM_GRADIENTS[3],
        cover: ALBUM_COVERS[3],
    },
    rv: {
        name: 'Chill Kill - Red Velvet',
        filepath: SONGS_FILEPATHS[4],
        bpm: SONGS_BPM[4],
        gradient: ALBUM_GRADIENTS[4],
        cover: ALBUM_COVERS[4],
    },
}*/
